module.exports = __webpack_public_path__ + "img/blog-list-view.0d685a87.png";